export enum ToggleSize {
  LG = 'lg',
  RG = 'rg'
}
